import * as Sentry from '@sentry/react';

const dsn = import.meta.env.VITE_SENTRY_DNS;
const mode = import.meta.env.MODE;
const release = import.meta.env.VITE_APP_VERSION || 'dev';

Sentry.init({
  dsn,
  environment: mode,
  release,
  // Adjust this value in production (e.g., 0.2 for 20% of transactions)
  tracesSampleRate: 1.0,
  // the number of nested fields in object to show
  normalizeDepth: 10,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // 10% of sessions; 100% of sessions that hit an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  beforeSend(event) {
    if (mode === 'development') return null;
    return event;
  },
});
